/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Content_ManualInputs */

const en_directory_submit_content_manual = /** @type {(inputs: Directory_Submit_Content_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fill in manually`)
};

const zh_directory_submit_content_manual = /** @type {(inputs: Directory_Submit_Content_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`手动填写`)
};

/**
* | output |
* | --- |
* | "Fill in manually" |
*
* @param {Directory_Submit_Content_ManualInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_content_manual = /** @type {((inputs?: Directory_Submit_Content_ManualInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Content_ManualInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_content_manual(inputs)
	return zh_directory_submit_content_manual(inputs)
});
export { directory_submit_content_manual as "directory.submit.content.manual" }